import { CalendarIcon } from "lucide-react";
import { DateTimePicker } from "~/components/ui";
import { cn } from "~/lib/utils.ts";

import { ErrorProps, FormError } from ".";

interface Props {
  label: string;
  required?: boolean;
  errors?: ErrorProps;
  value?: string | undefined;
  onChange: (option: string | undefined) => void;
  maxDate?: Date | undefined;
}
const ClearDateTimePicker = ({ clear }: { clear(): void }) => (
  <div>
    <small className="cursor-pointer hover:underline" onClick={() => clear()}>
      Clear
    </small>
  </div>
);

export default function FormDateTimeInput({
  label,
  required,
  errors,
  value,
  onChange,
}: Props) {
  return (
    <div className="w-full">
      <label className="space-y-1 capitalize">
        <div
          className={cn("text-base font-medium", {
            "text-danger-500": errors?.error,
          })}
        >
          {label} {required && <span className="text-danger-400">*</span>}
        </div>

        <div className="w-full">
          <DateTimePicker
            selected={value ? new Date(value) : undefined}
            onChange={(date: any) => {
              onChange(date?.toISOString());
            }}
            value={value && (new Date(value) as unknown as string)}
            showTimeSelect
            showIcon
            icon={
              <div className="order-2">
                <CalendarIcon
                  className="mr-0 h-4 w-4 text-primary-500"
                  size={20}
                />
              </div>
            }
            dateFormat="MMMM d, yyyy h:mm aa"
            showPopperArrow={false}
            className={cn(
              "order-1 flex h-10 w-full rounded-md border border-input bg-white px-2 py-1 text-sm ring-offset-zinc-900 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-zinc-900 disabled:cursor-not-allowed disabled:opacity-50",
              value ? "text-primary-500" : "text-muted-foreground",
            )}
          />
          <ClearDateTimePicker clear={() => onChange("")} />
        </div>
        <FormError error={errors?.error} message={errors?.message} />
      </label>
    </div>
  );
}
